exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".busy *:not(.submit-warn) {\n  opacity: 0.5;\n  z-index: 9999; }\n\nh4.mv-total {\n  min-width: 162px;\n  text-align: right; }\n\n.overlay {\n  position: relative; }\n\nimg.busySpin {\n  margin-top: 48px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 96px; }\n\n.fc-title {\n  font-size: 16px;\n  font-weight: bold; }\n\n.movement {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .movement span {\n    font-size: 14px;\n    font-weight: bold; }\n\nh4.mv-total {\n  min-width: 162px;\n  text-align: right;\n  transition: 0.2s; }\n\n.discr {\n  color: #fff !important;\n  background: #c92100 !important; }\n\n.float-itm {\n  position: relative; }\n\n.invalid-tip {\n  pointer-events: none;\n  color: #ebafa6 !important;\n  position: absolute !important;\n  top: 0;\n  left: 12px;\n  font-size: 12px; }\n\n.ng-invalid:not(.ng-pristine) {\n  border-color: #ebafa6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-float-control/form-float-control.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-float-control/form-float-control.component.scss
// module chunks = main